module.exports = __webpack_public_path__ + "img/seyi.d17aa2bf.png";